import { createFileRoute } from "@tanstack/react-router";

import { Onboarding } from "@/web/routes/_protected/-onboarding/-Onboarding";

export const Route = createFileRoute("/_protected/onboarding/")({
  component: OnboardingFork,
});

function OnboardingFork() {
  return <Onboarding />;
}
